module.exports = __webpack_public_path__ + "static/media/testAudio.8569b064.mp3";